module.exports = __webpack_public_path__ + "img/wps-excel.83db4cbf.png";